
import NavHeader from './NavHeader';
import styles from './contact-us.module.css';
import Footer from '../shared/Footer';


const ContactUs = () => {
    return (
        <>
        <NavHeader />

        <div className={styles.contactUsContainer}>
            <h1>Contact Us</h1>
            <p><b>If you have need any assistance, please reach out to us:</b></p>
            <ul>
                <li>Email:
                    <a href="mailto:reception@merilite.com">reception@merilite.com</a>
                </li>
                <br/>
                <li>Developer Profile:
                    <a href="https://www.linkedin.com/in/nitish-shankar17" target="_blank" rel="noopener noreferrer">
                        LinkedIn
                    </a>
                </li>
                {/* <li>Phone: <a href="tel:+1234567890">+1 (234) 567-890</a></li> */}
            </ul>
             <p><b>Request Account or Data Deletion</b></p>
            <ul>
                <li>To request deletion of your account and all associated data, email us at
                    <a href="mailto:reception@merilite.com"> reception@merilite.com </a>
                    with the subject line "Delete My Account" with your same registered email address. We will process your request within 7 days. Please note that this action is irreversible, and you will lose access to any content or information associated with your account. Upon account deletion, we permanently delete your profile, email, location data, messages, call logs, uploaded media, and connections. Anonymized usage data that cannot be linked back to you may be retained for analytics. Though if it was involved in a reported violation, related records may be retained for a limited period for safety purposes, thankyou.
                </li>
               
            </ul>
        </div>
        <Footer />
        </>
    );
};

export default ContactUs;
